"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
const axios_1 = __importDefault(require("axios"));
const profile_1 = require("./profile");
const retry_on_fail_1 = require("./retry-on-fail");
const timeout_1 = require("./timeout");
class Request {
    constructor(axiosInstance = axios_1.default, logger, profileNetworkRequests) {
        this.axiosInstance = axiosInstance;
        this.logger = logger;
        this.profileNetworkRequests = profileNetworkRequests;
        if (process.env.DD_SERVICE) {
            this.setUserAgentHeader(process.env.DD_SERVICE);
        }
    }
    setUserAgentHeader(userAgentVal) {
        this.axiosInstance.defaults.headers.common['User-Agent'] = userAgentVal;
    }
    async get(uri, options) {
        return (await (0, profile_1.profilePromise)({
            method: 'get',
            uri: this.axiosInstance.getUri(Object.assign({ url: uri }, options)),
            promise: this.axiosInstance.get(uri, options),
            logger: this.logger,
            shouldLog: this.profileNetworkRequests,
        })).data;
    }
    async post(uri, options, content) {
        return (await (0, profile_1.profilePromise)({
            method: 'post',
            uri: this.axiosInstance.getUri(Object.assign({ url: uri }, options)),
            promise: this.axiosInstance.post(uri, content, options),
            logger: this.logger,
            shouldLog: this.profileNetworkRequests,
        })).data;
    }
    async put(uri, options, content) {
        return (await (0, profile_1.profilePromise)({
            method: 'put',
            uri: this.axiosInstance.getUri(Object.assign({ url: uri }, options)),
            promise: this.axiosInstance.put(uri, content, options),
            logger: this.logger,
            shouldLog: this.profileNetworkRequests,
        })).data;
    }
    async patch(uri, options, content) {
        return (await (0, profile_1.profilePromise)({
            method: 'patch',
            uri: this.axiosInstance.getUri(Object.assign({ url: uri }, options)),
            promise: this.axiosInstance.patch(uri, content, options),
            logger: this.logger,
            shouldLog: this.profileNetworkRequests,
        })).data;
    }
    async head(uri, options) {
        return (await (0, profile_1.profilePromise)({
            method: 'head',
            uri: this.axiosInstance.getUri(Object.assign({ url: uri }, options)),
            promise: this.axiosInstance.head(uri, options),
            logger: this.logger,
            shouldLog: this.profileNetworkRequests,
        })).data;
    }
    async delete(uri, options) {
        return (await (0, profile_1.profilePromise)({
            method: 'delete',
            uri: this.axiosInstance.getUri(Object.assign({ url: uri }, options)),
            promise: this.axiosInstance.delete(uri, options),
            logger: this.logger,
            shouldLog: this.profileNetworkRequests,
        })).data;
    }
    async json(uri, options = {}) {
        return (await (0, profile_1.profilePromise)({
            method: options.method || 'get',
            uri: this.axiosInstance.getUri(Object.assign({ url: uri }, options)),
            promise: this.axiosInstance.request(Object.assign(Object.assign({}, options), { responseType: 'json', url: uri })),
            logger: this.logger,
            shouldLog: this.profileNetworkRequests,
        })).data;
    }
    async send(uri, requestConfig = {}, retryParams = {}) {
        const makeRequest = async () => {
            return (0, profile_1.profilePromise)({
                method: requestConfig.method || 'get',
                uri: this.axiosInstance.getUri(Object.assign({ url: uri }, requestConfig)),
                promise: this.axiosInstance.request(Object.assign(Object.assign({}, requestConfig), { responseType: 'json', url: uri })),
                logger: this.logger,
                shouldLog: this.profileNetworkRequests,
            });
        };
        const tryRequest = async () => {
            let error = null;
            const result = await makeRequest().catch((err) => {
                error = err;
                return null;
            });
            return { result, error };
        };
        if ((0, retry_on_fail_1.isRetryParams)(retryParams)) {
            return await (0, retry_on_fail_1.retryOnFail)(makeRequest, retryParams);
        }
        else {
            return await (0, timeout_1.requestAndRetry)(tryRequest, retryParams.retries, uri);
        }
    }
}
exports.Request = Request;
//# sourceMappingURL=request.js.map